import * as React from 'react';

import { ExternalCoachAction } from 'bundles/ai-coach-platform/components/patterns/chat/ExternalCoachAction';
import { useAiAssistanceExperimentData } from 'bundles/front-page/providers/AiAssistanceExperimentProvider';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';

import _t from 'i18n!nls/front-page';

const CoachButton = () => {
  const { setCoachOpen } = useCoachState();

  const { aiAssistanceEnabled } = useAiAssistanceExperimentData();

  if (!aiAssistanceEnabled) {
    return null;
  }

  const label = _t('Have a quick question before signing up?');

  return (
    <ExternalCoachAction
      size="small"
      key="coach"
      variant="secondary"
      newSessionOnClick={true}
      onClick={() => {
        setCoachOpen(true);
      }}
      label={label}
      message={label}
      config={{
        // TODO: add coach mode and action id
        coachModeId: '',
        coachActionId: 'BASIC',
      }}
    />
  );
};

export default CoachButton;
